import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { makeStyles, Box, Typography, Card, Grid, List, ListItem } from '@material-ui/core';
import PropTypes__default from 'prop-types';
import SvgCheckCircle1 from '../../common/streamlinehq/img/streamline-regular/interface-essential/form-validation/check-circle-1.svg.js';
import StreamlineIcon from '../../widgets/streamline-icon/StreamlineIcon.js';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import { retrieveContentfulImage } from '../../common/image.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    viewNoContainer: _defineProperty(_defineProperty({
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      paddingTop: theme.spacing(7.5),
      paddingBottom: theme.spacing(13)
    }, theme.breakpoints.down("sm"), {
      paddingBottom: theme.spacing(7.5)
    }), theme.breakpoints.down("md"), {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2)
    }),
    mainImage: _defineProperty({
      width: theme.spacing(15.5),
      height: theme.spacing(15.5)
    }, theme.breakpoints.down("xs"), {
      width: theme.spacing(10),
      height: theme.spacing(10)
    }),
    mainTitle: {
      marginTop: theme.spacing(3)
    },
    mainCard: _defineProperty({
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      borderRadius: theme.spacing(1),
      maxWidth: theme.spacing(143),
      width: "100%",
      marginTop: theme.spacing(5)
    }, theme.breakpoints.down("sm"), {
      marginTop: theme.spacing(4)
    }),
    mainCardImg: _defineProperty({
      objectFit: "cover",
      height: "100%",
      width: "100%"
    }, theme.breakpoints.down("sm"), {
      maxHeight: theme.spacing(62.5),
      objectPosition: "top"
    }),
    smallSizeAlignCenter: _defineProperty({}, theme.breakpoints.down("sm"), {
      textAlign: "center"
    }),
    chargesBox: {
      height: "100%",
      border: "1px solid lightgrey",
      borderRadius: "5px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    },
    chargesContainer: _defineProperty({
      marginTop: theme.spacing(3)
    }, theme.breakpoints.down("xs"), {
      marginTop: theme.spacing(2)
    }),
    chargesSkele: {
      margin: theme.spacing(0),
      width: "100%"
    },
    subtitle: {
      color: theme.palette.text.medium
    },
    list: _defineProperty({
      paddingTop: theme.spacing(3.5),
      paddingBottom: theme.spacing(3.5)
    }, theme.breakpoints.down("sm"), {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5)
    }),
    listItem: {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5)
    },
    checkIcon: {
      marginRight: theme.spacing(1.6),
      color: theme.palette.primary[900],
      width: theme.spacing(2.8),
      height: theme.spacing(2.8)
    },
    buttonSkele: {
      marginLeft: "auto",
      marginRight: "auto",
      height: theme.spacing(6),
      width: theme.spacing(25)
    }
  };
});
var Investment = function Investment(_ref) {
  var iconTitle = _ref.iconTitle,
    iconUrl = _ref.iconUrl,
    title = _ref.title,
    listItems = _ref.listItems,
    imageTitle = _ref.imageTitle,
    imageUrl = _ref.imageUrl,
    cardTitle = _ref.cardTitle,
    cardFootnote = _ref.cardFootnote,
    boxItems = _ref.boxItems,
    buttons = _ref.buttons,
    bgColor = _ref.bgColor;
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen,
    isMediumScreen = _useBreakpoints.isMediumScreen,
    isLargeScreen = _useBreakpoints.isLargeScreen,
    isExtraLargeScreen = _useBreakpoints.isExtraLargeScreen;
  var getSizesByScreen = function getSizesByScreen() {
    if (isMediumScreen() || isLargeScreen() || isExtraLargeScreen()) {
      return {
        width: 405
      };
    }
    return {
      width: 900
    };
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    className: classes.viewNoContainer,
    bgcolor: bgColor
  }, iconUrl && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    src: retrieveContentfulImage(iconUrl, {
      width: 124,
      height: 124
    }),
    className: classes.mainImage,
    alt: iconTitle || ""
  }), title && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h3",
    component: "h2",
    className: classes.mainTitle
  }, title), /*#__PURE__*/React__default.createElement(Card, {
    elevation: 6,
    className: classes.mainCard
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xl: 5,
    lg: 5,
    md: 5,
    sm: 12,
    xs: 12
  }, imageUrl && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    className: classes.mainCardImg,
    src: retrieveContentfulImage(imageUrl, getSizesByScreen()),
    alt: imageTitle || ""
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xl: 7,
    lg: 7,
    md: 7,
    sm: 12,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(Box, {
    pr: isExtraSmallScreen() ? 1.5 : 6,
    pl: isExtraSmallScreen() ? 1.5 : 6,
    pt: isExtraSmallScreen() ? 3 : 6,
    pb: isExtraSmallScreen() ? 3 : 6
  }, cardTitle && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h4",
    component: "h3",
    className: classes.smallSizeAlignCenter
  }, cardTitle), /*#__PURE__*/React__default.createElement(Grid, {
    className: classes.chargesContainer,
    container: true,
    spacing: 1
  }, boxItems === null || boxItems === void 0 ? void 0 : boxItems.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      key: index,
      xl: 6,
      lg: 6,
      md: 6,
      sm: 6,
      xs: 12
    }, /*#__PURE__*/React__default.createElement(Box, {
      py: 3,
      px: 4,
      className: classes.chargesBox
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "subtitle2",
      component: "div"
    }, item === null || item === void 0 ? void 0 : item.title), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h4",
      component: "div"
    }, item === null || item === void 0 ? void 0 : item.text), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption",
      className: classes.subtitle
    }, item === null || item === void 0 ? void 0 : item.subtitle)));
  })), /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(List, {
    className: classes.list
  }, listItems === null || listItems === void 0 ? void 0 : listItems.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(ListItem, {
      key: index,
      disableGutters: true,
      className: classes.listItem
    }, /*#__PURE__*/React__default.createElement(StreamlineIcon, {
      className: classes.checkIcon
    }, /*#__PURE__*/React__default.createElement(SvgCheckCircle1, null)), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body1"
    }, item));
  }))), buttons, cardFootnote && cardFootnote.trim() !== "" && /*#__PURE__*/React__default.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption"
  }, cardFootnote)))))));
};
Investment.propTypes = {
  bgColor: PropTypes__default.string,
  iconTitle: PropTypes__default.string,
  iconUrl: PropTypes__default.string,
  title: PropTypes__default.string,
  listItems: PropTypes__default.array,
  imageTitle: PropTypes__default.string,
  imageUrl: PropTypes__default.string,
  cardTitle: PropTypes__default.string,
  cardFootnote: PropTypes__default.string,
  boxItems: PropTypes__default.array,
  buttons: PropTypes__default.node
};

export { Investment as default };
//# sourceMappingURL=Investment.js.map
